/**
 * Dimensions rangées dans un bloc image qui n'en porte aucune, en pixels — celles de l'éditeur
 * d'origine.
 *
 * Elles servent deux fois, et c'est pourquoi elles vivent ici plutôt qu'en double : quand un bloc
 * image est déposé, et quand son image est retirée. Sans cette seconde remise, le bloc garderait la
 * taille de l'image partie et la retrouverait à la suivante (VJ-3133).
 *
 * Elles ne décident pas de ce que le canevas montre d'un emplacement vide : celui-ci occupe la
 * largeur de sa section et une hauteur fixe, ces dimensions-ci ne décrivant qu'une image.
 */
export const EMAIL_DEFAULT_IMAGE_SIZE = {width: 360, height: 240} as const;
